var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-list',_vm._l((_vm.params.menuList),function(item,index){return _c('DbMenuNavItem',{key:index,attrs:{"item":item,"current-path":_vm.currentPath,"keep-child-view":_vm.keepChildView,"is-dark-mode":_vm.isDarkMode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }